import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import {
  AccordionItemWrapper,
  AccordionHeaderButton,
  AccordionHeaderLeft,
  AccordionTitle,
  AccordionIconLeft,
  AccordionChevron,
  AccordionBody,
} from './style';

interface AccordionItemProps {
  title: string;
  icon: IconProp;          // tipando o ícone do Font Awesome
  defaultOpen?: boolean;
  children: React.ReactNode;
}

export function AccordionItem({
  title,
  icon,
  defaultOpen = false,
  children,
}: AccordionItemProps) {
  const [open, setOpen] = useState<boolean>(defaultOpen);

  return (
    <AccordionItemWrapper>
      <AccordionHeaderButton
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        type="button"
      >
        <AccordionIconLeft>
          <FontAwesomeIcon icon={icon} />
        </AccordionIconLeft>

        <AccordionTitle>{title}</AccordionTitle>

        <AccordionChevron open={open}>
          <FontAwesomeIcon icon={faAngleRight} />
        </AccordionChevron>
      </AccordionHeaderButton>

      {open && <AccordionBody>{children}</AccordionBody>}
    </AccordionItemWrapper>
  );
}
